import React from 'react';

type SectionHeaderProps = {
    title: string;
    /** Optional control shown opposite the title, e.g. the contest section's share button. */
    action?: React.ReactNode;
};

const SectionHeader = ({ title, action }: SectionHeaderProps) => {
    return (
        <div className="flex flex-row items-center justify-between space-x-[6px]">
            <h2 className="text-headline-20 lg:text-headline-24 text-center lg:text-left mb-[24px]">{title}</h2>
            {action && <div className="mb-[24px] shrink-0">{action}</div>}
        </div>
    );
};

export default SectionHeader;
